import { render, staticRenderFns } from "./pie2.vue?vue&type=template&id=9ac6b164&scoped=true&"
import script from "./pie2.vue?vue&type=script&lang=js&"
export * from "./pie2.vue?vue&type=script&lang=js&"
import style0 from "./pie2.vue?vue&type=style&index=0&id=9ac6b164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac6b164",
  null
  
)

export default component.exports